import React from "react";

function Motif({ type = "heart", className = "" }) {
  if (type === "swirl") {
    return (
      <svg className={className} viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <path
          d="M30 8c8 4 12 14 8 22-4 9-16 12-24 6-7-5-8-15-3-21 4-5 12-6 17-2 4 3 5 9 2 13-2 3-7 4-10 2"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  if (type === "spark") {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12 1.5l1.2 7.3L20 12l-6.8 3.2L12 22.5l-1.2-7.3L4 12l6.8-3.2L12 1.5z" />
      </svg>
    );
  }

  if (type === "petal") {
    return (
      <svg className={className} viewBox="0 0 16 24" fill="currentColor" aria-hidden="true">
        <ellipse cx="8" cy="12" rx="5" ry="10" />
      </svg>
    );
  }

  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 20.6S4.4 16 2.2 11.7C.4 8.4 2.2 5 6 5c1.9 0 3.5 1.1 4 2.7C10.5 6.1 12.1 5 14 5c3.8 0 5.6 3.4 3.8 6.7C15.6 16 12 20.6 12 20.6z" />
    </svg>
  );
}

export default Motif;
